module.exports = __webpack_public_path__ + "img/yx5-zh.ce706729.jpg";